import { useState } from "react";
import CountrieCodes from "./country-code-helpers/CountrieCodes";
import CountryCodeHeader from "./country-code-helpers/cc-header/CountryCodeHeader";
import { FieldValues, UseFormReturn } from "react-hook-form";
import CountryCodeDrawer from "./country-code-helpers/CountryCodeDrawer";
import { IDialCodeCountry } from "@/api/AppApi/services/company/interfaces/api-company-interfaces";

// export const codeNameAtom = atom({
//   name: "",
//   dialCountryCode: {} as IDialCodeCountry,
//   form: {} as UseFormReturn<FieldValues, any>,
// });

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  dialCountryCode: IDialCodeCountry;
  form: UseFormReturn<FieldValues, any>;
  name: string;
}

const SelectCountryCode: React.FC<Props> = ({
  show,
  setShow,
  form,
  dialCountryCode,
  name,
}) => {
  const [code, setCode] = useState("");
  return (
    <CountryCodeDrawer show={show} setShow={setShow}>
      <CountryCodeHeader
        code={code}
        setCode={setCode}
        onClose={() => setShow(false)}
      />
      <CountrieCodes
        form={form}
        name={name}
        dialCountryCode={dialCountryCode}
        code={code}
        onSelect={() => {
          setShow(false);
          setCode("");
        }}
      />
    </CountryCodeDrawer>
  );
};

export default SelectCountryCode;
